<mat-nav-list class="operations-list">
	<div *ngIf="ShouldNoOperationsMessageDisplay" class="no-operations-message">
		<mat-icon class="no-operations-icon">list_alt</mat-icon>
		<h3>All Clear!</h3>
		<p>No new operations are in progress</p>
	</div>
	<mat-list-item *ngFor="let backgroundOperation of BackgroundOperations; index as operationIndex" id="background-operation-item-{{operationIndex}}" (click)="OnOperationClick(backgroundOperation)" class="operations-list-item">
		<mat-icon
			matListItemAvatar
			[class]="GetStatusClass(backgroundOperation, true)"
		>
			{{ GetIcon(backgroundOperation) }}
		</mat-icon>
		<div matListItemTitle>
			{{ backgroundOperation.Description }}
		</div>
		<div matListItemLine class="operation-status">
			<span [class]="GetStatusClass(backgroundOperation)">
				{{ GetStatusDisplayName(backgroundOperation) }}
			</span>
		</div>
	</mat-list-item>
</mat-nav-list>